<script>
import { mapGetters, mapState } from 'vuex'
import { pricingMixin } from '../../mixins/pricingMixin'

export default {
  props: {
    subscription: {
      type: Object,
      required: true,
      default: () => {}
    },
    isSelected: {
      type: Boolean,
      required: true,
      default: true
    },
    noSub: {
      type: Boolean,
      required: false,
      default: false
    },
    hideSubscribedFlag: {
      type: Boolean,
      required: false,
      default: false
    },
    fromChallenge: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [pricingMixin],
  data () {
    return {}
  },
  mounted () {},
  computed: {
    ...mapState(['subscriptions', 'user']),
    ...mapGetters(['primaryColorRgb', 'activeSubscription', 'activeChallenge', 'activeChallengePrice', 'hasNativeSubscription', 'hasActiveNativeSubscription']),
    isMatchingLegacy () {
      /* TO DO Possibility to check for more than 1 active product with the same interval */
      return this.activeSubscription && this.activeSubscription.plan && this.activeSubscription.plan.interval === this.subscription.interval && this.subscription.interval_count === this.activeSubscription.plan.interval_count
    },
    priceInterval () {
      const interval = this.subscription.interval
      const intervalCount = this.subscription.interval_count
      if (interval === 'year') { return 'Annually' }
      if (interval === 'month') { if (intervalCount === 1) { return 'Monthly' } if (intervalCount === 3) { return 'Quarterly' } }
      if (interval === 'week') { return 'Weekly' }
      if (interval === 'day') { return 'Daily' } else {
        return ''
      }
    },
    isCurrent () {
      return (this.activeSubscription && this.activeSubscription.plan.id === this.subscription.id) ||
        (this.hasNativeSubscription && this.hasActiveNativeSubscription &&
          this.user.profile.subscription_plan_type && this.user.profile.subscription_plan_type.includes(this.priceInterval.toLowerCase()))
    },
    cardText () {
      if (this.activeSubscription) {
        if (this.subscription.id === this.activeSubscription.plan.id || this.isMatchingLegacy) {
          return this.isMatchingLegacy ? 'Keep Current Subscription' : 'Keep Current Subscription'
        } else {
          if (this.subscription && this.subscription.interval &&
          this.subscription.interval === 'year' && this.activeChallengePrice && this.activeChallengePrice.metadata.freeWithAnnual) {
            return 'Upgrade to Annual subscription and get the challenge FREE'
          } else {
            return `Change to ${this.priceInterval === 'Annually' ? 'Annual' : this.priceInterval} subscription`
          }
        }
      } else if (this.hasNativeSubscription && this.hasActiveNativeSubscription) {
        if (this.user.profile.subscription_plan_type && this.user.profile.subscription_plan_type.includes(this.priceInterval.toLowerCase())) {
          return 'Keep Current Subscription'
        } else {
          if (this.subscription && this.subscription.interval &&
          this.subscription.interval === 'year' && this.activeChallengePrice && this.activeChallengePrice?.metadata?.freeWithAnnual) {
            return 'Upgrade to Annual subscription and get the challenge FREE'
          } else {
            return `Change to ${this.priceInterval === 'Annually' ? 'Annual' : this.priceInterval} subscription`
          }
        }
      } else {
        if (this.subscription.amount < 1) {
          return 'Acceso a la Aplicación'
        } else {
          return `${this.subscription.interval === 'year' ? 'Annual' : this.priceInterval} Subscription`
        }
      }
    },
    challengePrice () {
      let challengePrice
      let currencySymbol
      let upperCaseCurrency
      if (this.activeChallengePrice) {
        upperCaseCurrency = this.activeChallengePrice.currency.toUpperCase()
        challengePrice = (this.activeChallengePrice.unit_amount / 100).toFixed(2)
        currencySymbol = this.currency_symbols[upperCaseCurrency]
        return `${currencySymbol}${challengePrice}`
      } else {
        return null
      }
    },
    subscriptionAmount () {
      const price = this.subscription.amount / 100
      return price.toFixed(2)
    },
    getAnnualSavingPercentage () {
      if (this.subscriptions && this.subscriptions.length > 0 && this.subscriptions[0].plans && this.subscriptions[0].plans.length > 0) {
        const plans = this.subscriptions[0].plans
        let monthlyPrice
        let annualPrice
        plans.forEach(subscription => {
          if (this.$_getPlanNickName(subscription) === 'monthly') {
            monthlyPrice = subscription
          }
          if (this.$_getPlanNickName(subscription) === 'annually') {
            annualPrice = subscription
          }
        })
        const percentage = 100 - ((annualPrice.amount / (monthlyPrice.amount * 12)) * 100)

        return Math.round(percentage)
      } else {
        return null
      }
    }
  },
  methods: { }
}
</script>

<template>
  <b-row
    :class="['card-container', { isSelected: isSelected, fromChallenge: fromChallenge }]"
    :style="{
      '--primaryColor': `rgba(${primaryColorRgb}, ${1})`,
      '--selectedBG': `rgba(${primaryColorRgb}, ${0.22})`
    }"
    @click="$emit('select-price', subscription)"
  >
   <!-- Enable if neeeded
   <div class="term">{{priceInterval}}</div> -->
    <b-col :class="['card price', { isNew: subscription.interval === 'year' && !activeSubscription && activeChallengePrice && activeChallengePrice.metadata && activeChallengePrice.metadata.freeWithAnnual, isSelected: isSelected }]">
      <div class="row card-row">
        <div class="col-1 check-col">
          <div v-if="!noSub" class="check">
            <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="isSelected" v-bind:class="'icon-check'" v-bind:svg-inline="''" @click="$emit('select-price', subscription)" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M33 66c18.225 0 33-14.775 33-33S51.225 0 33 0 0 14.775 0 33s14.775 33 33 33z" fill="url(#paint0_linear)" fill-opacity=".6"/><path d="M17.368 33.55l4.466-5.321 8.645 7.255 15.748-18.116 5.243 4.56L35.803 39.95l-4.466 5.322L17.368 33.55z" fill="#fff"/><defs><linearGradient id="paint0_linear" x1="33" y1="0" x2="33" y2="66" gradientUnits="userSpaceOnUse"><stop stop-color="#55BCF5"/><stop offset="1" stop-color="#3E4FE2"/></linearGradient></defs></svg>
            <div
              v-if="!isSelected"
              class="icon-uncheck"
              @click="$emit('select-price', subscription)"
            />
          </div>
        </div>
        <div class="col sub-details">
          <div class="row nick-name">
            <p v-if="cardText">{{cardText}}</p>
            <p v-if="subscription.interval !== 'year' && activeSubscription">Pay {{challengePrice}} for the challenge</p>
            <p v-if="subscription.interval == 'year' && activeChallengePrice && !activeChallengePrice.metadata.freeWithAnnual">Best Value! Choose the annual plan, save {{ getAnnualSavingPercentage }}%!</p>
          </div>
        </div>
        <div class="col total-price">
          <p v-if="!isCurrent && !isMatchingLegacy" class="sub-price">{{$_currencySymbol(subscription)}}{{subscriptionAmount}}</p>
          <p v-if="!isCurrent && subscription.interval === 'year'" class="save">Save {{ getAnnualSavingPercentage }}%</p>
        </div>
        <!-- Enable if neeeded -->
        <!-- <div v-if="isCurrent && !hideSubscribedFlag" class="col already-subscribed">
          <p>Already Subscribed</p>
        </div> -->
      </div>
    </b-col>
    <div v-if="subscription.interval === 'year' && !activeSubscription && activeChallengePrice && activeChallengePrice.metadata && activeChallengePrice.metadata.freeWithAnnual" :class="['best-value-section', { isSelected: isSelected }]">
      <p>Best Value! Choose the annual plan, save {{ getAnnualSavingPercentage }}% and get the challenge for FREE</p>
    </div>
  </b-row>
</template>

<style lang="scss" scoped>
@import '@design';

.card-container {
  position: relative;
  width: 90%;
  margin-right: auto;
  margin-left: auto;
  &:not(.isSelected) {
    transition: transform 300ms;
    transition-timing-function: ease-out;
    &:hover {
      transform: scale(1.01);
    }
    cursor: pointer;
  }
  &.isSelected {
    &.fromChallenge {
      .price {
       &:not(.isNew) {
         border: 3px solid var(--primaryColor);
       }
     }
    }
    .price {
      background-color: var(--selectedBG);
      border-radius: 8px;
    }
  }
  .term {
    position: absolute;
    z-index: 2;
    border-top-left-radius: 8px;
    background-color: var(--primaryColor);
    color: white;
    top: 0px;
    padding: 0rem 1.2rem;
    text-transform: capitalize;
  }
  .best-value-section {
    padding: 0.5rem 0;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border-right: 1px solid var(--primaryColor);
    border-left: 1px solid var(--primaryColor);
    border-bottom: 1px solid var(--primaryColor);
    margin-bottom: 0.5rem;
    &.isSelected {
      border-right: 3px solid var(--primaryColor);
      border-left: 3px solid var(--primaryColor);
      border-bottom: 3px solid var(--primaryColor);
    }
    color: var(--primaryColor);
    width: 100%;
    p {
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 18px;
      margin-bottom: unset;
      width: 80%;
      margin-right: auto;
      margin-left: auto;
    }
  }
  .price {
    position: relative;
    margin-bottom: 0.5rem;
    border-radius: 8px;
    width: 100%;
    max-height: 5.3rem;
    height: 5.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .card-row {
      flex-wrap: unset;
      width: 100%;
      .sub-details {
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
    }
    .col-2 {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 0 0 12.666667%;
      max-width: 12.666667%;
    }
    p {
      font-size: 1.5rem;
      font-weight: 900;
      margin-bottom: unset;
    }
    .nick-name {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      p {
        font-style: normal;
        font-weight: bold;
        font-size: 19px;
        line-height: 26px;
        align-items: center;
        color: #000000;
        text-align: start;
        &:nth-child(2) {
          font-size: 16px;
          line-height: 16px;
          font-weight: normal;
        }
      }
    }
    .col-1 {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 0 0 10.333333%;
      max-width: fit-content;
      &.check-col {
        .check {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .icon-check {
            width: 1.5rem;
            height: 1.5rem;
            path {
              &:first-child {
                fill: var(--primaryColor);
                fill-opacity: 1;
              }
            }
          }
          .icon-uncheck {
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 50%;
            border: 1px black solid;
            cursor: pointer;
          }
        }
      }
      p {
        font-style: normal;
        font-weight: 600;
        font-size: 25px;
        line-height: 30px;
        display: flex;
        align-items: center;
        text-align: center;
        color: rgba(0, 0, 0, 0.85);
      }
    }
    .total-price {
      display: flex;
      justify-content: center;
      align-items: center;
      // margin-right: 2rem;
      flex-direction: column;
      max-width: fit-content;
      position: relative;
      .sub-price {
        white-space: nowrap;
        font-style: normal;
        font-weight: 600;
        font-size: 25px;
        line-height: 23px;
        display: flex;
        align-items: center;
        text-align: right;
        color: rgba(0, 0, 0, 0.85);
      }
      .save {
        font-family: $base-font-family;
        font-style: normal;
        font-weight: 800;
        font-size: 14px;
        line-height: 19px;
        text-align: right;
        text-transform: uppercase;
        color: var(--primaryColor);
        white-space: nowrap;
        // position: absolute;
        // bottom: -4%;
      }
    }
    .already-subscribed {
       display: flex;
      justify-content: flex-end;
      align-items: center;
      p {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 18px;
        color: rgba(0, 0, 0, 0.85);
      }
    }
    &.isNew {
      border-radius: unset;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      margin-bottom: 0px;
      &.isSelected {
        border: unset;
        border-right: 3px solid var(--primaryColor);
        border-left: 3px solid var(--primaryColor);
        border-top: 3px solid var(--primaryColor);
      }
    }
  }
  @media screen and (max-width: 600px) {
    .price {
      padding-right: unset;
      padding-left: unset;
      .card-row {
        .check-col {
          margin-right: unset !important;
        }
        .col {
          .nick-name {
            p {
              font-size: 15px;
              line-height: 17px;
            }
          }
        }
        .already-subscribed {
          text-align: center;
        }
        .sub-details {
          // width: 70%;
        }
        .total-price {
          margin-right: unset;
          // width: 25%;
          // max-width: 25%;
          .sub-price {
            font-size: 20px;
            line-height: 22px;
          }
          .save {
            font-size: 13px;
          }
        }
      }
    }
  }
}
</style>
